import { create } from 'zustand';

type WalletTokensState = {
  walletTokenPendingVerification: {
    userId: string;
    status?: string;
    paymentMethod: string;
  } | null;
  walletTokenPendingDeletion: {
    paymentMethod: string;
    paymentProvider: string;
  } | null;
  mobilePayInitiatedFromOnboarding: boolean;
};

type WalletTokensActions = {
  setWalletTokenPendingVerification: (
    verification: {
      userId: string;
      status: string;
      paymentMethod: string;
    } | null
  ) => void;
  setWalletTokenPendingDeletion: (
    deletion: { paymentMethod: string; paymentProvider: string } | null
  ) => void;
  setMobilePayInitiatedFromOnboarding: (value: boolean) => void;
};

export const useWalletTokenVerifyStore = create<
  WalletTokensState & WalletTokensActions
>((set) => ({
  walletTokenPendingVerification: null,
  walletTokenPendingDeletion: null,
  mobilePayInitiatedFromOnboarding: false,
  setWalletTokenPendingVerification: (verification) =>
    set({ walletTokenPendingVerification: verification }),
  setWalletTokenPendingDeletion: (deletion) =>
    set({ walletTokenPendingDeletion: deletion }),
  setMobilePayInitiatedFromOnboarding: (value) =>
    set({ mobilePayInitiatedFromOnboarding: value }),
}));
